import api from "./api";

const SID_KEY = "ria_sid";

export function getSessionId() {
  let sid = localStorage.getItem(SID_KEY);
  if (!sid) {
    sid = `s_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
    localStorage.setItem(SID_KEY, sid);
  }
  return sid;
}

export function track(type, meta = {}, path) {
  try {
    api
      .post("/analytics/track", {
        type,
        path: path ?? window.location.pathname,
        session_id: getSessionId(),
        meta,
      })
      .catch(() => {});
  } catch {
    /* no-op */
  }
}
